// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getClinicExamStatistics } from "../../api";
import { ClinicExamStatsType } from "../../types";

export const useClinicExamStats = (
  clinicId: string | undefined,
  payload: { recentFilterDate: string }
) => {
  const { getToken } = useTokenAccess();

  return useQuery<ClinicExamStatsType>({
    queryKey: ["clinic-exam-stats", clinicId, payload],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      const controller = new AbortController();
      return getClinicExamStatistics(
        token,
        clinicId,
        payload,
        controller.signal
      );
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
